// Function loadShopItemsCarouselWidget loads the ShopItemsCarouselWidget class by dynamically importing the js on demand if needed

export function loadShopItemsCarouselWidget($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-items-Carouse-widget-chunk" */ '../widgets/shopItemsCarouselWidget').then(wg => {

		const { ShopItemsCarouselWidget } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopItemsCarouselWidget"]');

		if(!$wg) {
			// console.info('ShopItemsCarouselWidget: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopItemsCarouselWidget"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopItemsCarouselWidget($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopItemsCarouselWidget($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopItemsCarouselWidget widget');

}
